export default __webpack_public_path__ + "3bc906f9b1a6a1f10510dcd973f4963f.png";